const autoNgTemplateLoaderTemplate1 = require('./stackFromTemplateForm.html');

import angular from 'angular';

angular.module('portainer.app').component('stackFromTemplateForm', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  bindings: {
    template: '=',
    formValues: '=',
    state: '=',
    createTemplate: '<',
    unselectTemplate: '<',
  },
  transclude: {
    advanced: '?advancedForm',
  },
});
